<template>
  <div class="act-award">
    <table>
      <thead>
      <tr class="table-header">
        <th class="num">
          <i class="icon_award-1"></i>累计邀请人数</th>
        <th class="user">
          <i class="icon_award-2"></i>总下载次数奖励
        </th>
        <th class="create-time">
          <i class="icon_award-3"></i>日下载次数奖励
        </th>
        <th class="create-time">
          <i class="icon_award-4"></i>VIP奖励
        </th>
      </tr>
      </thead>
      <tbody class="table-body">
      <tr v-for="(vo,idx) in awardList" :key="idx + 'award'">
        <td>{{ vo.invite_total }}人</td>
        <td>+{{ vo.download_total }}次</td>
        <td>{{ vo.day_download }}次/天</td>
        <td>{{ vo.award }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { awardList } from './common/module'
export default {
  name: "InviteActAward",
  data() {
    return {
      awardList
    }
  }
}
</script>

<style lang="scss" scoped>
.act-award{
  //@include Position(1, 5, 50%, 2611px);
  @include Position(1, 5, 50%, 1419px);
  transform: translateX(-50%);
}
table {
  width: 1105px;
  background: #FFFCF7;
  border-radius: 20px;
  //margin: 82px 0 0 19px;
  //position: fixed;
  top: 100px;
  overflow: hidden;

  .table-header {
    font-size: 16px;
    font-weight: 400;
    //height: 68px;
    line-height: 68px;
    //background: #F9FBFF;
    background-color: transparent;
    border-radius: 20px 20px 0px 0px;
    color: #20395B;

    th {
      font-weight: normal;
      i{
        margin-right: 15px;
      }

      .icon_award-1{
        @include BgImage(23px,21px,'act/invite-friends/award/icon_award-1.png');
      }
      .icon_award-2{
        @include BgImage(25px,20px,'act/invite-friends/award/icon_award-2.png');
      }
      .icon_award-3{
        @include BgImage(29px,19px,'act/invite-friends/award/icon_award-3.png');
      }
      .icon_award-4{
        @include BgImage(21px,21px,'act/invite-friends/award/icon_award-4.png');
      }
    }

  }

  .table-body {
    tr {
      height: 68px !important;

      &:nth-child(2n-1) {
        background: #FFFFFF;
      }

      td {
        text-align: center;
        padding: 0;
        display: table-cell;
        vertical-align: middle;
        height: 56px !important;
        font-size: 18px;
        font-weight: bold;
        color: #20395B;
      }
    }
  }
}
</style>


<!--
    邀请奖励 page
-->
